// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateComment-cls1_DMT","cls2":"CreateComment-cls2_FJB CreateComment-cls1_DMT"};